import { Link } from "react-router-dom";
import { GALLERY } from "@/lib/site";
import { ArrowUpRight } from "lucide-react";

export default function GalleryPreview({ items = GALLERY.slice(0, 6) }) {
  return (
    <section data-testid="gallery-preview" className="section-pad">
      <div className="container-page">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-12">
          <div>
            <p className="overline mb-3">Recent work</p>
            <h2 className="heading-2 max-w-2xl">Quality you can see — even before we finish.</h2>
          </div>
          <Link to="/gallery" data-testid="gallery-view-all" className="btn-ghost shrink-0">
            View all projects <ArrowUpRight className="w-4 h-4" />
          </Link>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-5">
          {items.map((g, i) => (
            <figure
              key={i}
              data-testid={`gallery-tile-${i}`}
              className={`relative overflow-hidden rounded-md border border-brand-line bg-white group ${
                i === 0 ? "row-span-2 col-span-2 md:col-span-2" : ""
              }`}
            >
              <div className={`${i === 0 ? "aspect-[4/5]" : "aspect-[4/3]"} overflow-hidden`}>
                <img src={g.src} alt={g.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.04]" loading="lazy" />
              </div>
              <figcaption className="absolute inset-x-0 bottom-0 p-4 bg-gradient-to-t from-brand-obsidian/85 to-transparent">
                <p className="text-[10px] uppercase tracking-[0.2em] text-white/70">{g.category}</p>
                <p className="font-heading font-bold text-white text-sm md:text-base">{g.title}</p>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
